import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';
import React from 'react';

const NewBadge: React.FunctionComponent = () => {
  const { badge } = useStyles();

  return (
    <div className={badge}>
      <CustomizedTypography variant="caption" color="error">
        NEW
      </CustomizedTypography>
    </div>
  );
};

export default NewBadge;

const useStyles = makeStyles((theme) => ({
  badge: {
    height: '22px',
    borderRadius: '4px',
    padding: '2px 6px',
    backgroundColor: colorSet.errorLight
  }
}));
